import AddSickCalloutCtrl from '../AddSickCalloutCtrl';

import formUrl from './sickCalloutForm.html';

export default {
  templateUrl: formUrl,
  controller: AddSickCalloutCtrl,
  controllerAs: 'ctrl',
  bindings: {
    data: '=',
    modal: '=',
    type: '@',
  },
};
